import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getData } from "../../services/generalService";
import { AccountAchObj } from "../../utils/types";

const initialState: AccountAchObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getAccountAchData = createAsyncThunk(
  "loans/getAccountAchDetails",
  async (url: string, thunkAPI) => {
    try {
      const data = await getData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const accountAchSlice = createSlice({
  name: "accountsACH",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAccountAchData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAccountAchData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getAccountAchData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default accountAchSlice.reducer;
